import { Link } from "../lib/router-compat";
import { OverlayLink } from "./OverlayLink";

const sections: Array<{ heading: string; items: Array<{ label: string; to?: string; hash?: string }> }> = [
  {
    heading: "Programs",
    items: [
      { label: "Pan Institute Classes", to: "/classes" },
      { label: "Maine Pan Production", to: "/maine-pan-production" },
      { label: "Pan Coalition", to: "/pan-coalition" },
      { label: "Atlantic Clarion", to: "/atlantic-clarion" },
      { label: "Planet Pan Steel Band", to: "/planet-pan" },
    ],
  },
  {
    heading: "Performances",
    items: [
      { label: "Calendar", to: "/calendar" },
      { label: "Monday Nights!", to: "/monday-nights" },
      { label: "Annual Pan Festival", to: "/pan-festival" },
      { label: "Last Night!", to: "/last-night" },
      { label: "Recordings", to: "/recordings" },
    ],
  },
  {
    heading: "Interactive",
    items: [
      { label: "Tutorial", to: "/learn-to-play" },
      { label: "Visualizer", to: "/visualizer" },
    ],
  },
  {
    heading: "Connect",
    items: [
      { label: "Sheet Music", to: "/sheet-music" },
      { label: "History of Pan in Maine", to: "/history" },
      { label: "Nigel P. Chase", to: "/nigel" },
      { label: "Contact", to: "/contact" },
    ],
  },
];

export function SiteFooter() {
  return (
    <footer className="border-t border-border/40 mt-32 bg-background">
      <div className="mx-auto max-w-5xl px-5 pt-16 pb-10">
        <div className="grid gap-12 md:grid-cols-[1.2fr_repeat(3,1fr)]">
          <div>
            <Link
              to="/"
              className="text-[10px] uppercase tracking-[0.5em] text-foreground/90 hover:text-foreground transition-colors whitespace-nowrap"
            >
              Pan Institute
            </Link>
            <p className="mt-3 text-[12px] leading-relaxed text-foreground/55 max-w-[22ch]">
              A home for the steel pan — its craft, its sound, and the people who carry it forward.
            </p>
          </div>

          {sections.map((s) => (
            <div key={s.heading}>
              <div className="text-[11px] font-medium text-foreground/90 mb-3">
                {s.heading}
              </div>
              <ul className="space-y-2">
                {s.items.map((it) =>
                  it.to ? (
                    <li key={it.label}>
                      {it.to === "/learn-to-play" || it.to === "/visualizer" ? (
                        <Link
                          to={it.to}
                          className="text-[12px] text-foreground/55 hover:text-foreground transition-colors"
                        >
                          {it.label}
                        </Link>
                      ) : (
                        <OverlayLink
                        to={it.to}
                        className="text-[12px] text-foreground/55 hover:text-foreground transition-colors"
                      >
                        {it.label}
                      </OverlayLink>
                      )}
                    </li>
                  ) : (
                    <li key={it.label}>
                      <a
                        href="#"
                        className="text-[12px] text-foreground/55 hover:text-foreground transition-colors"
                      >
                        {it.label}
                      </a>
                    </li>
                  ),
                )}
              </ul>
            </div>
          ))}
        </div>

      </div>
    </footer>
  );
}
